import React from 'react';
import {ArrowLeft} from "lucide-react";
import CreateSeriesButton from "./CreateSeriesButton";
import PreviewVideo from "./PreviewVideo";
import YoutubeMetaDataForm from "./YoutubeMetaDataForm";
import TikTokMetaDataForm from "./TikTokMetaDataForm";

const PreviewSection = ({
                            youtubePostMetadata,
                            isLinkingYoutube,
                            getDeclaration,
                            handlePrivacyStatusChange,
                            handleTitleChange,
                            creatorInfo,
                            handleTiktokMetadataChange,
                            showHoverNotification,
                            tiktokPostMetadata,
                            handleCommercialContentChange,
                            handleYoutubeTitleChange,
                            handleYoutubePrivacyStatusChange,
                            handleYoutubeMetadataChange,
                            handleTikTokSignIn,
                            isLinkingTikTok,
                            handleGoogleSignIn,
                            linkedAccounts,previewVideo,setShowingPreview,setShowHoverNotification,isPublishDisabled,handlePublish,seriesData,
                            isPublishing}) => {
    const renderYoutubeMetadataForm = () => {
        if (!seriesData.platforms.includes('YouTube Shorts')) return null;
        if (!linkedAccounts['YouTube Shorts'])
            return (
                <div className='mt-8 p-6 bg-white rounded-lg shadow'>
                    <h3 className='text-2xl font-semibold mb-4'>
                        YouTube Account Required
                    </h3>
                    <p className='mb-4'>
                        You need to link your YouTube account to post content.
                    </p>
                    <p className='mb-4 text-sm text-indigo-600 font-medium'>
                        Don't worry! Your progress will be saved as a draft while you link
                        your account.
                    </p>
                    <CreateSeriesButton
                        type='button'
                        onClick={handleGoogleSignIn}
                        disabled={isLinkingYoutube}
                        className='mr-4'
                    >
                        {isLinkingYoutube ? 'Linking in progress' : 'Link YouTube Account'}
                    </CreateSeriesButton>
                    {isLinkingYoutube && (
                        <p className='mt-2 text-sm text-gray-600'>
                            Please complete the linking process in the opened window. This
                            page will update automatically once your account is linked.
                        </p>
                    )}
                </div>
            );
        return <YoutubeMetaDataForm youtubePostMetadata={youtubePostMetadata}
                                    handleYoutubeTitleChange={handleYoutubeTitleChange}
                                    handleYoutubePrivacyStatusChange={handleYoutubePrivacyStatusChange}
                                    handleYoutubeMetadataChange={handleYoutubeMetadataChange}/>
    };
    const renderTiktokMetadataForm = () => {
        if (!seriesData.platforms.includes('TikTok')) return null;
        if (!linkedAccounts['TikTok'])
            return <div className='mt-8 p-6 bg-white rounded-lg shadow'>
                <h3 className='text-2xl font-semibold mb-4'>
                    TikTok Account Required
                </h3>
                <p className='mb-4'>
                    You need to link your TikTok account to post content.
                </p>
                <p className='mb-4 text-sm text-indigo-600 font-medium'>
                    Don't worry! Your progress will be saved as a draft while you link
                    your account.
                </p>
                <CreateSeriesButton
                    type='button'
                    onClick={handleTikTokSignIn}
                    disabled={isLinkingTikTok}
                    className='mr-4'
                >
                    {isLinkingTikTok ? 'Linking in progress' : 'Link TikTok Account'}
                </CreateSeriesButton>
                {isLinkingTikTok && (
                    <p className='mt-2 text-sm text-gray-600'>
                        Please complete the linking process in the opened window. This
                        page will update automatically once your account is linked.
                    </p>
                )}
            </div>
        return <TikTokMetaDataForm getDeclaration={getDeclaration} handlePrivacyStatusChange={handlePrivacyStatusChange}
                                   handleTitleChange={handleTitleChange}
                                   creatorInfo={creatorInfo}
                                   seriesData={seriesData}
                                   setShowHoverNotification={setShowHoverNotification}
                                   handleTiktokMetadataChange={handleTiktokMetadataChange}
                                   showHoverNotification={showHoverNotification}
                                   tiktokPostMetadata={tiktokPostMetadata}
                                   handleCommercialContentChange={handleCommercialContentChange}/>

    };
    return <div className='space-y-8'>
            <div className='flex justify-between items-center mb-6'>
                <h3 className='text-2xl font-semibold text-gray-800'>
                    Preview
                </h3>
                <div className='flex space-x-4'>
                    <button
                        onClick={() => setShowingPreview(false)}
                        className='flex items-center px-4 py-2 text-sm font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200'
                    >
                        <ArrowLeft className='w-5 h-5 mr-2' />
                        Back to Edit
                    </button>
                    <div
                        onMouseEnter={() => setShowHoverNotification(true)}
                        onMouseLeave={() => setShowHoverNotification(false)}
                        className='relative'
                    >
                        <CreateSeriesButton
                            type='button'
                            className={`${
                                isPublishDisabled
                                    ? 'opacity-50 cursor-not-allowed'
                                    : ''
                            }`}
                            onClick={handlePublish}
                            disabled={
                                seriesData.platforms.length === 0 ||
                                isPublishing ||
                                isPublishDisabled
                            }
                        >
                            {isPublishing
                                ? 'Publishing...'
                                : seriesData.platforms.length === 0
                                    ? 'No platforms selected'
                                    : seriesData.platforms.length === 1
                                        ? `Publish to ${seriesData.platforms[0]}`
                                        : `Publish to ${seriesData.platforms.join(' and ')}`}
                        </CreateSeriesButton>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-8'>
                <PreviewVideo videoUrl={previewVideo}/>
                <div className='lg:col-span-1 overflow-auto'>
                    <h4 className='text-xl font-semibold mb-4 text-gray-800'>
                        Video Detail
                    </h4>
                    <dl className='grid grid-cols-1 gap-y-3'>
                        <div>
                            <dt className='text-sm font-medium text-gray-500'>
                                Platforms
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900'>
                                {seriesData.platforms.join(', ')}
                            </dd>
                        </div>
                        <div>
                            <dt className='text-sm font-medium text-gray-500'>
                                Content Type
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900'>
                                {seriesData.contentType}
                            </dd>
                        </div>
                        {seriesData.customTopic && (
                            <div>
                                <dt className='text-sm font-medium text-gray-500'>
                                    Custom Topic
                                </dt>
                                <dd className='mt-1 text-sm text-gray-900'>
                                    {seriesData.customTopic}
                                </dd>
                            </div>
                        )}
                        <div>
                            <dt className='text-sm font-medium text-gray-500'>
                                Language
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900'>
                                {seriesData.language}
                            </dd>
                        </div>
                        {/*<div>*/}
                        {/*  <dt className='text-sm font-medium text-gray-500'>*/}
                        {/*    Voice*/}
                        {/*  </dt>*/}
                        {/*  <dd className='mt-1 text-sm text-gray-900'>*/}
                        {/*    {seriesData.voice}*/}
                        {/*  </dd>*/}
                        {/*</div>*/}
                        <div>
                            <dt className='text-sm font-medium text-gray-500'>
                                Duration
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900'>
                                {seriesData.duration === 1
                                    ? '30-60 seconds'
                                    : '60-90 seconds'}
                            </dd>
                        </div>
                        <div>
                            <dt className='text-sm font-medium text-gray-500'>
                                Tags
                            </dt>
                            <dd className='mt-1 text-sm text-gray-900'>
                                {seriesData && seriesData.tags ?seriesData.tags.join(' | '): ''}
                            </dd>
                        </div>
                        {/*<div>*/}
                        {/*  <dt className='flex justify-between items-center mb-2'>*/}
                        {/*    <span className='text-sm font-medium text-gray-500'>*/}
                        {/*      Script*/}
                        {/*    </span>*/}
                        {/*    <button*/}
                        {/*      onClick={() => setIsEditingScript(!isEditingScript)}*/}
                        {/*      className='text-sm text-indigo-600 hover:text-indigo-800'*/}
                        {/*    >*/}
                        {/*      {isEditingScript ? 'Cancel' : 'Edit'}*/}
                        {/*    </button>*/}
                        {/*  </dt>*/}
                        {/*  <dd className='mt-1'>*/}
                        {/*    {isEditingScript ? (*/}
                        {/*      <div className='space-y-4'>*/}
                        {/*        <textarea*/}
                        {/*          value={editedScript}*/}
                        {/*          onChange={(e) =>*/}
                        {/*            setEditedScript(e.target.value)*/}
                        {/*          }*/}
                        {/*          className='w-full p-2 text-sm text-gray-800 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500'*/}
                        {/*          style={{ height: 'auto' }}*/}
                        {/*          rows={20} // Set rows to a larger number to avoid scrolling*/}
                        {/*        />*/}
                        {/*        <button*/}
                        {/*          onClick={handleScriptUpdate}*/}
                        {/*          className='px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'*/}
                        {/*        >*/}
                        {/*          Update Script*/}
                        {/*        </button>*/}
                        {/*      </div>*/}
                        {/*    ) : (*/}
                        {/*      <pre className='whitespace-pre-wrap text-sm text-gray-800 p-2 bg-gray-50 rounded-md max-h-32 overflow-y-auto'>*/}
                        {/*        {seriesData.script}*/}
                        {/*      </pre>*/}
                        {/*    )}*/}
                        {/*  </dd>*/}
                        {/*</div>*/}
                    </dl>
                </div>
                <div className='lg:col-span-1'>
                    {renderYoutubeMetadataForm()}
                    {renderTiktokMetadataForm()}
                </div>
            </div>
        </div>

};

export default PreviewSection;
